module.exports = __webpack_public_path__ + "static/media/commerce.422fec10.png";